import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import loader from "../../Images/ajax-loader.gif";

import { ToastContainer, toast } from "react-toastify";
import {
  insertOfficersDetails,
  getOfficersDetails,
  deleteOfficersDetails,
  updateOfficersDetails,
  disableOfficersDetails,
  get_entity_type,
  getDistrict,
  getBlockByDistrict,
  getVillageByBlock,
} from "../../api/User";
import "../Admin/table.css"
const LineDepartmentDetails = ({ department, designationFacilitator }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [otherDepartmentInput, setOtherDepartmentInput] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const officerTypeOptions = [
    "State Nodal Officer (SNO)",
    "District Nodal Officer (DNO)",
    "Block Nodal Officer (BNO)",
    "Gram Panchayat Nodal Officer (GPNO)"
  ];

  const [formData, setFormData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    officer_name: "",
    email: "",
    entity_name: "",
    entity_type: "3",
    district: "",
    block: "",
    gram_panchayat: "",
    department_name: "",
    other_department_name: "",
    officer_type: "",
  });

  const [formErrors, setFormErrors] = useState({
    designation: "",
    mobile_no: "",
    officer_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
    department_name: "",
    officer_type: "",
    other_department_name: "",


  });
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [EntityTypeErr, setEntityTypeErr] = useState("");
  const [lgdCode, setLgdCode] = useState("");
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [DepartmentNameErr, setDepartmentNameErr] = useState("");
  const [othersDepartmentInput, setOthersDepartmentInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const [officers, setofficers] = useState([]);

  const [editData, setEditData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    officer_name: "",
    email: "",
    entity_name: "",
    entity_type: "3",
    district: "",
    block: "",
    gram_panchayat: "",
    department_name: "",
    otherDepartmentName: "",
    officer_type: "",

  });
  const [othersInput, setOthersInput] = useState(false);
  const [entityTypes, setEntityTypes] = useState([]);
  const [editOthersInput, setEditOthersInput] = useState(false);
  const [editOtherValue, setEditOtherValue] = useState("");
  const [entity, setEntity] = useState("");
  const [districts, setDistricts] = useState([]);
  const [entityName, setEntityName] = useState([]);
  const navigate = useNavigate();
  const [resources, setResources] = useState([]);
  const [showOtherDesignation, setShowOtherDesignation] = useState(false);


  const fetchData = async () => {

    const data = {

      role_id: role_id,
      gp_data_id: "all",

    };
    try {
      const res = await getOfficersDetails(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  useEffect(() => {
    handleReset();
    setOthersInput(false);
    setOthersDepartmentInput(false);
    fetchData();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (officers && officers.length > 0) {
        const payload = {
          officers: officers.map(item => ({
            user_id: userId,
            full_name: item.full_name,
            officer_type: item.officer_type,
            mobile_no: item.mobile_no,
            email: item.email,
            entity_type: 3,
            designation: item.designation === 'Other' ? item.other_designation : item.designation,
            department_name: item.department_name,
            district: item.district_name,
            district_code: item.district_code,
            block: item.block_name,
            block_code: item.block_code,
            gram_panchayat: item.gram_panchayat,
            gram_panchayat_code: item.gram_panchayat_code,
          }))
        };


        console.log("Payload to submit:", payload);

        const response = await insertOfficersDetails(token, payload);

        if (response && response.status === 'success') {
          toast.success("Record Inserted Successfully", { autoClose: 1000 });
          fetchData();


          setFormData({
            officer_name: '',
            mobile_no: '',
            email: '',
            entity_type: '3',
            district_name: '',
            block_name: '',
            gram_name: '',
            designation: '',
            department_name: '',
            officer_type: '',
            other_department_name: '',
          });


          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
          setofficers([]);
          fetchData();
          setShowTable(false);
        } else {
          console.error("Failed to insert record:", response);
          toast.error("Failed to insert record. Please try again.");
        }
      } else {
        toast.error("No officers to submit", { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error("An error occurred while submitting the form.");
    } finally {
      setLoading(false);
    }
  };









  //validations
  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";

    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";

    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";

    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";

    return "";
  };

  const validateOfficerName = (officerName) => {
    if (!officerName) {
      return "Officer Name is required.";
    }
    const invalidCharRegex = /[^A-Z\s]/;
    if (invalidCharRegex.test(officerName)) {
      return "Officer Name cannot contain numbers or special characters.";
    }
    return "";
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleChange = (event) => {

    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : prevErrors[name],
    }));

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "officer_name") {
      const upperCaseValue = value.toUpperCase();

      if (upperCaseValue.charAt(0) === ' ' || upperCaseValue.charAt(0) === '0') {
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: 'Officer Name should not be empty or start with 0',
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: upperCaseValue,
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateOfficerName(upperCaseValue),
        }));
      }
    }
    else if (name === "email") {
      const lowercaseValue = value.toLowerCase();
      setFormData((prevState) => ({
        ...prevState,
        [name]: lowercaseValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateEmail(lowercaseValue) ? "" : "Invalid email format",
      }));
    }
    else if (name === "designation") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));


    }
    else if (name === "department_name") {
      if (value === "Other") {
        setOtherDepartmentInput(true);
      } else {
        setOtherDepartmentInput(false);
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          other_department_name: "",
        }));
      }
    }
    else if (name === "entity_type") {
      let updatedEntityName = '';
      if (value === "Village Panchayat") {
        updatedEntityName = entityName.village;
      } else if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }

      setFormData((prevState) => ({
        ...prevState,
        entity_type: value,
        entity_name: updatedEntityName,
        district_name: value === "District Panchayat" ? "" : prevState.district_name,
        block_name: ["Intermediate Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block_name,
        gram_name: value === "Village Panchayat" ? "" : prevState.gram_name,
      }));

      setEntity(updatedEntityName);
    } if (name === "district") {
      const updatedData = districts.filter((item) => item.district_code == value);

      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);


      setFormData((prevState) => ({
        ...prevState,
        district: value,
        district_name: updatedData[0].district,
        district_code: value,
      }));


      setFormErrors((prevState) => ({
        ...prevState,
        district: "",
      }));
    }

    if (name === "block") {
      const selectedBlock = blocks.find((block) => block.block_code == value);
      setVillages([]);
      const distcode = formData.district;
      fetchVillages(distcode, value);
      setFormData((prevState) => ({
        ...prevState,
        block_name: selectedBlock?.block,
        block_code: value,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        block: "",
      }));
    }
    if (name === "gram_panchayat") {
      const selectedVillage = villages.find(
        (village) => village.gram_panchayat_code == value
      );
      setFormData((prevState) => ({
        ...prevState,
        gram_panchayat: value,
        gram_panchayat_name: selectedVillage?.gram_panchayat || "",
        gram_panchayat_code: value,

      }));
      setFormErrors((prevState) => ({
        ...prevState,
        gram_panchayat: "",
      }));
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  // const handleDepartmentChange = (e) => {
  //   console.log(e.target.value);
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     other_department_name: e.target.value,
  //   }));
  // };

  const handleEdit = (index) => {

    const selectedRecord = filteredData[index];
    const isOtherDesignation = !designationFacilitator.includes(selectedRecord.designation);
    const isOtherDepartment = !department.includes(selectedRecord.department_name);

    setEditData({
      ...selectedRecord,
      designation: isOtherDesignation ? "Other" : selectedRecord.designation,
      customDesignation: isOtherDesignation ? selectedRecord.designation : "",

      department_name: isOtherDepartment ? "Other" : selectedRecord.department_name,
      otherDepartmentName: isOtherDepartment ? selectedRecord.department_name : "",

      entity_type: selectedRecord.entity_type,
    });
    fetchBlocks(selectedRecord.district_code);
    setVillages([]);
    fetchVillages(selectedRecord.district_code, selectedRecord.block_code);

    setOthersInput(isOtherDesignation);
    setOthersDepartmentInput(isOtherDepartment);

    setOpenEditModal(true);
  };
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : prevErrors[name],
    }));
    if (name === "entity_type") {
      let updatedEntityName = '';
      if (value === "Village Panchayat") {
        updatedEntityName = entityName.village;
      } else if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }
      setEditData((prevState) => {
        let updatedEntityType = value;
        let updatedEntityName = prevState.entity_type;

        if (name === "entity_type" && value == 3) {
          updatedEntityType = "Village Panchayat";
        }

        return {
          ...prevState,
          [name]: value,
          entity_type: updatedEntityType,
          entity_name: updatedEntityName,
          district: value === "District Panchayat" ? "" : prevState.district,
          block: ["Block Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block,
          gram_panchayat: value === "Village Panchayat" ? "" : prevState.gram_panchayat,
        };
      });


      setDistricts([]);
      setBlocks([]);
      setVillages([]);
      fetchDistricts();
    } else if (name === "district") {
      setEditData((prevState) => ({
        ...prevState,
        district: value,
        block: "",
        gram_panchayat: "",
      }));
      fetchBlocks(value);
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);
    } else if (name === "block_code") {
      const district_code = editData.district_code;
      setEditData((prevState) => ({
        ...prevState,
        block: value,
        gram_panchayat: "",
      }));
      setVillages([]);
      fetchVillages(district_code, value);
    } else if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setEditData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "officer_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      setEditData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: cleanedValue.trim() ? "" : "Officer Name is required.",
      }));
    }
    else if (name === "designation") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      setEditData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: cleanedValue.trim() ? "" : "Designation is required.",
      }));
    }


    else if (name === 'department_name') {
      const isOther = value === "Other";
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
        otherDepartmentName: isOther ? prevState.otherDepartmentName || "" : "",
      }));
      setOthersDepartmentInput(isOther);
    } else if (name === 'otherDepartmentName') {
      setEditData((prevState) => ({
        ...prevState,
        otherDepartmentName: value,
      }));
    }




    if (name === "entity_type") {

      setFormData({
        ...formData,
        entity_type: value,
        district: "",
        block: "",
        gram_panchayat: "",
      });
      setDistricts([]);
      setBlocks([]);
      setVillages([]);

      fetchDistricts();
    } else if (name === "district") {

      setFormData({
        ...formData,
        district: value,
        block: "",
        gram_panchayat: "",
      });
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);
    } else if (name === "block") {
      setFormData({
        ...formData,
        block: value,
        gram_panchayat: "",
      });
      setVillages([]);
      const district_code = formData.district;
      fetchVillages(district_code, value);
    } else {

      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name === "block") {
      const district_code = formData.district;
      fetchVillages(district_code, value);
    }
    if (name === "district_code") {
      fetchBlocks(value);
    }
    else if (name === "district_code") {
      fetchDistricts(value);

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));

    }

    else if (name === "block") {

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    else if (name === "gram_panchayat") {

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleEditSubmit = async (event) => {
    event.preventDefault();


    const safeTrim = (value) => (value ? value.trim() : "");


    const errors = {
      officer_name: safeTrim(editData.officer_name) ? "" : "Officer Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
      email: editData.email ? "" : "Email ID is required.",
      entity_type: editData.entity_type ? "" : "Entity Type is required.",
      designation: editData.designation ? "" : "Designation is required.",
      district: editData.district ? "" : "District is required.",
      block: editData.block ? "" : "Block is required.",
      gram_panchayat: editData.gram_panchayat ? "" : "Gram Panchayat is required.",
      officer_type: editData.officer_type ? "" : "Officer Type is required.",

    };
    console.log('Validation Errors:', errors);
    setErrors(errors);
    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (hasErrors) {
      console.log('Form has errors, submission halted.');
      return;
    }
    try {
      const dataToSubmit = {
        ...editData,
        designation: editData.customDesignation || editData.designation,
        department_name: editData.otherDepartmentName || editData.department_name
      };

      console.log('Data to submit:', dataToSubmit);

      const res = await updateOfficersDetails(token, dataToSubmit);
      console.log('API Response:', res);

      if (res.status === "success") {
        toast.success(res.message, { autoClose: 1000 });
        fetchData();
        handleReset();
        setOpenEditModal(false);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.", { autoClose: 1000 });
    }

    setOthersInput(false);
    setOthersDepartmentInput(false);
  };



  const handleReset = () => {
    setFormData({
      user_id: userId,
      designation: "",
      mobile_no: "",
      officer_name: "",
      email: "",
      entity_type: "3",
      other_designation: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
      officer_type: "",
    });
    setOtherDepartmentInput(false);
    setFormErrors({
      designation: "",
      mobile_no: "",
      officer_name: "",
      email: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
      officer_type: "",
    });
    setEntity("")
    setOthersInput(false);
    setOthersDepartmentInput(false);
  };
  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteIndex !== null) {
      try {
        const idToDelete = filteredData[deleteIndex].id;
        await deleteOfficersDetails(token, idToDelete);
        const updatedData = filteredData.filter((_, i) => i !== deleteIndex);
        setFilteredData(updatedData);
        toast.success("Deleted successfully", { autoClose: 1000 });
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
      }
    }
    setOpenDialog(false);
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
  };
  const handleToggleActive = (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, active: !row.active } : row
    );
    setFilteredData(updatedData);
  };

  const handleDisableButton = async (is_active, ID) => {
    const newIsActive = is_active === 1 ? 0 : is_active;
    const data = {
      id: ID,

    };
    try {
      const res = await disableOfficersDetails(token, data);
      if (res.status === "success") {

        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === ID ? { ...row, is_active: newIsActive } : row
          )
        );
        toast.success("Updated successfully", { autoClose: 1000 });
        fetchData();
      } else {
        toast.error("An error occurred while updating the item.", { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", { autoClose: 1000 });
    }
  };
  const handleDesignationChange = (e) => {
    console.log(e.target.value);
    formData.designation = e.target.value
  };
  const handleEditDesignationChange = (e) => {
    const newValue = e.target.value;
    console.log(newValue);
    setEditData((prevState) => ({
      ...prevState,
      designation: newValue,
    }));
    setEditOtherValue(newValue);

  };

  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        const res = await get_entity_type(token);
        if (res.status === "success") {
          setEntityTypes(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching entity types:", error);
        toast.error("An error occurred while fetching entity types.", { autoClose: 1000 });
      }
    };

    fetchEntityTypes();
  }, [token]);




  const handleAddResource = (e) => {
    setShowTable(true);
    e.preventDefault();
    const errors = {};
    const trimmedFullName = formData.officer_name.trim();


    if (!formData.officer_type) {
      errors.officer_type = 'Officer type is required';
    }
    if (!trimmedFullName) {
      errors.officer_name = 'Officer Name is required';
    } else if (!/^[A-Z\s]+$/.test(trimmedFullName)) {
      errors.officer_name = 'Officer Name must be uppercase letters and spaces only';
    }
    if (!formData.mobile_no) {
      errors.mobile_no = 'Mobile No is required';
    } else {
      const trimmedMobile = formData.mobile_no.trim();
      if (trimmedMobile.length > 10) {
        errors.mobile_no = 'Mobile No cannot exceed 10 digits';
      } else if (!/^\d{10}$/.test(trimmedMobile)) {
        errors.mobile_no = 'Mobile No must be exactly 10 digits';
      } else if (/^0{10}$/.test(trimmedMobile)) {
        errors.mobile_no = 'Mobile No cannot be all zeroes';
      } else if (trimmedMobile.startsWith('0')) {
        errors.mobile_no = 'Mobile No cannot start with 0';
      }
    }
    if (!formData.email) {
      errors.email = 'Email ID is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid Email ID format';
    }
    if (!formData.designation) {
      errors.designation = 'Designation is required';
    }
    if (formData.designation === 'Other' && !formData.other_designation) {
      errors.other_designation = 'Other Designation is required';
    }
    if (!formData.district) {
      errors.district = 'District Name is required';
    }
    if (!formData.department_name) {
      errors.department_name = 'Department name is required';
    } else if (formData.department_name === 'Other') {
      const otherDepartmentName = formData.other_department_name ? formData.other_department_name.trim() : '';

      if (!otherDepartmentName) {
        errors.other_department_name = 'Other Department Name is required';
      }
    }
    if (!formData.officer_name) {
      errors.officer_name = 'Officer Name is required';
    }
    if (!formData.block) {
      errors.block = 'Block Name is required';
    }
    if (!formData.gram_panchayat) {
      errors.gram_panchayat = 'Gram Panchayat Name is required';
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;


    const newResource = {
      officer_type: formData.officer_type,
      full_name: formData.officer_name,
      mobile_no: formData.mobile_no,
      email: formData.email,
      designation: formData.designation === 'Other' ? formData.other_designation : formData.designation,
      department_name: formData.department_name === 'Other' ? formData.other_department_name : formData.department_name,
      district_name: formData.district_name,
      district_code: formData.district,
      block_name: formData.block_name,
      block_code: formData.block,
      gram_panchayat: formData.gram_panchayat_name,
      gram_panchayat_code: formData.gram_panchayat,
      entity_type: "Gram Panchayat",
    };


    setofficers((prevResources) => [...prevResources, newResource]);

    toast.success("Records added successfully!", { autoClose: 1000 });

    setFormData({
      officer_type: '',
      officer_name: '',
      mobile_no: '',
      email: '',
      designation: '',
      other_designation: '',
      department_name: '',
      district: '',
      district_code: '',
      block: '',
      block_code: '',
      gram_panchayat: '',
      gram_panchayat_code: '',
    });
  };

  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === "success") {
        setDistricts(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      toast.error("An error occurred while fetching districts.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchDistricts();
  }, []);


  const handleDeleteResource = (index) => {
    const updatedResources = resources.filter((_, i) => i !== index);
    setofficers(updatedResources);
  };

  const handleResetAllRows = () => {
    setofficers([]);
  };

  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(token, district_code);
      if (res.status === "success") {
        setBlocks(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };

  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(token, district_code, block_code);
      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      toast.error("An error occurred while fetching villages.", { autoClose: 1000 });
    }
  };

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid" style={{
        height: "95vh",
        backgroundColor: "ffffff",
        padding: "20px",
        marginTop: "-17px",
      }}>
        <div className="ms-2" style={{ height: "90vh" }}>
          <div
            style={{
              backgroundColor: '#fffff',
              padding: '16px',
              marginTop: "-32px",
              marginLeft: '-32px',
              marginRight: '-32px',
              paddingLeft: '48px',
              paddingRight: '48px',
            }}
          >
            <h2
              className="pt-10"
              style={{
                top: "0",
                left: "0",
                margin: "16px",
                fontWeight: "bold",
              }}
            >
              Line Department Details
            </h2>
          </div>


          <div style={{
            backgroundColor: "",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            margin: "16px"
          }}>

            <form className="row g-3 p-3" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <label
                  htmlFor="officer_type"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Officer Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.officer_type ? "is-invalid" : ""}`}
                  name="officer_type"
                  id="editOfficerType"
                  value={formData?.officer_type}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select Officer Type</option>
                  {officerTypeOptions?.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {formErrors.officer_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.officer_type}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label htmlFor="department_name" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Department Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.department_name ? "is-invalid" : ""}`}
                  name="department_name"
                  id="editDepartmentName"
                  value={formData?.department_name}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select Department Name</option>
                  {department?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {formErrors.department_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.department_name}
                  </p>
                )}
              </div>
              {otherDepartmentInput && (
                <div className="col-md-4">
                  <label
                    htmlFor="other_department_name"
                    className="form-label"
                    style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                  >
                    Other Department Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formErrors.other_department_name ? "is-invalid" : ""}`}
                    name="other_department_name"
                    placeholder="Enter Other Department Name"
                    id="other_department_name"
                    value={formData.other_department_name || ""}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      const trimmedValue = value.trimStart();


                      setFormData((prevState) => ({
                        ...prevState,
                        [name]: trimmedValue,
                      }));


                      if (trimmedValue !== "") {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          [name]: "",
                        }));
                      }
                    }}
                  />

                  {formErrors.other_department_name && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {formErrors.other_department_name}
                    </p>
                  )}
                </div>
              )}

              <div className="col-md-4">
                <label
                  htmlFor="officer_name"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Officer Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.officer_name ? "is-invalid" : ""}`}
                  name="officer_name"
                  id="officer_name"
                  value={formData.officer_name}
                  onChange={(e) => {
                    const value = e.target.value.trimStart();
                    const upperCaseValue = value.toUpperCase();

                    handleChange({ target: { name: "officer_name", value: upperCaseValue } });
                  }}
                  placeholder="Enter the Officer Name"
                />
                {formErrors.officer_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.officer_name}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="designation"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}>

                  Designation <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.designation ? "is-invalid" : ""}`}
                  name="designation"
                  id="designation"
                  value={formData.designation}
                  placeholder="Enter Designation"
                  onChange={(e) => {
                    const { name, value } = e.target;


                    const trimmedValue = value.trimStart();

                    setFormData((prevState) => ({
                      ...prevState,
                      [name]: trimmedValue,
                    }));


                    if (trimmedValue !== "") {
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "",
                      }));
                    }
                  }}
                />
                {formErrors.designation && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.designation}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="mobile_no"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.mobile_no ? "is-invalid" : ""}`}
                  name="mobile_no"
                  id="mobile_no"
                  value={formData.mobile_no}
                  placeholder="Enter the Mobile No"
                  maxLength={10}
                  onChange={(e) => {
                    const { name, value } = e.target;


                    const trimmedValue = value.trimStart().replace(/\D/g, '');


                    if (trimmedValue.charAt(0) === '0') {
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "Mobile number should not start with '0'.",
                      }));
                    } else if (trimmedValue.length > 10) {
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "Mobile number should not exceed 10 digits.",
                      }));
                    } else {
                      setFormData((prevState) => ({
                        ...prevState,
                        [name]: trimmedValue,
                      }));


                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "",
                      }));
                    }
                  }}
                />
                {formErrors.mobile_no && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.mobile_no}
                  </p>
                )}
              </div>


              <div className="col-md-4">
                <label
                  htmlFor="email"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Email ID <span style={{ color: "red", fontWeight: "800" }}>*</span>
                </label>
                <input
                  type="email"
                  className={`form-control ${formErrors.email ? "is-invalid" : ""}`}
                  name="email"
                  id="email"
                  value={formData.email}
                  placeholder="Enter the Email ID"
                  onChange={(e) => {
                    const { name, value } = e.target;

                    // Trim both leading and trailing spaces
                    const trimmedValue = value.trim();

                    // Email validation regex
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    // Update form data with the trimmed value
                    setFormData((prevState) => ({
                      ...prevState,
                      [name]: trimmedValue,
                    }));

                    // Validate email format
                    if (!emailRegex.test(trimmedValue)) {
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "Please enter a valid email address.",
                      }));
                    } else {
                      // Clear error if the email is valid
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: "",
                      }));
                    }
                  }}
                />
                {formErrors.email && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.email}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label htmlFor="entity_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Entity Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-control ${formErrors.entity_type ? "is-invalid" : ""}`}
                  name="entity_type"
                  id="entity_type1"
                  value={formData.entity_type || "3"}
                  onChange={handleChange}
                  disabled
                >
                  <option value="" disabled>
                    Select Entity Type
                  </option>
                  {entityTypes.map((item, index) => (
                    <option key={index} value={item.entity_code}>
                      {item.entity_name}
                    </option>
                  ))}
                </select>
                {formErrors.entity_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.entity_type}
                  </p>
                )}
              </div>

              {/* {(formData.entity_type == 1 ||
            formData.entity_type == 2 ||
            formData.entity_type == 3) &&  */}

              <div className="col-md-4">
                <label htmlFor="district" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  District Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.district ? "is-invalid" : ""}`}
                  name="district"
                  id="district"
                  value={formData.district || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select District Name
                  </option>
                  {districts?.map((district, index) => (
                    <option key={index} value={district.district_code}>
                      {district.district}
                    </option>
                  ))}
                </select>
                {formErrors.district && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.district}
                  </p>
                )}
              </div>
              {/* )} */}

              {/* {(formData.entity_type == 2 || formData.entity_type == 3) && ( */}
              <div className="col-md-4">
                <label htmlFor="block" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Block Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.block ? "is-invalid" : ""}`}
                  name="block"
                  id="block"
                  value={formData.block || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Block Name
                  </option>
                  {blocks?.map((block, index) => (
                    <option key={index} value={block.block_code}>
                      {block.block}
                    </option>
                  ))}
                </select>
                {formErrors.block && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.block}
                  </p>
                )}
              </div>
              {/* )} */}


              {/* {formData.entity_type == 3 && ( */}
              <div className="col-md-4">
                <label htmlFor="gram_panchayat" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Gram Panchayat Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.gram_panchayat ? "is-invalid" : ""}`}
                  // className="form-select"
                  name="gram_panchayat"
                  id="gram_panchayat"
                  value={formData.gram_panchayat || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Gram Panchayat Name
                  </option>
                  {villages?.map((village, index) => (
                    <option key={index} value={village.gram_panchayat_code}>
                      {village.gram_panchayat}
                    </option>
                  ))}
                </select>
                {formErrors.gram_panchayat && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.gram_panchayat}
                  </p>
                )}
              </div>
              <div className="d-flex justify-content-end">
                <div className="col-md-2 row mt-2">
                  <Button
                    variant="contained"
                    onClick={handleAddResource} sx={{
                      width: "70%",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      "&:hover": {
                        backgroundColor: "#4763E4",
                        color: "#fff"
                      },
                    }}
                  >
                    ADD
                  </Button>
                </div>
              </div>
              {officers.length > 0 && showTable && (
                <>
                  <div className="p-0" style={{ overflowX: 'auto', maxHeight: '33vh', marginTop: '20px' }}>
                    <Table aria-label="simple table">
                      <TableHead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          backgroundColor: "#3235761A",
                        }}
                      >
                        <TableRow>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            SR NO.
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            OFFICER TYPE
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            DEPARTMENT NAME
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            OFFICER NAME
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            DESIGNATION
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            MOBILE NUMBER
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            EMAIL ID
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            ENTITY TYPE
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            DISTRICT
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            BLOCK
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            GRAM PANCHAYAT
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {officers.map((type, index) => (
                          <TableRow key={type.id}
                            style={{
                              backgroundColor: index % 2 === 0 ? "#ffffff" : " #3235760A"
                            }}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{type.officer_type}</TableCell>
                            <TableCell align="center">{type.department_name}</TableCell>
                            <TableCell align="center">{type.full_name}</TableCell>
                            <TableCell align="center">{type.customDesignation || type.designation}</TableCell>
                            <TableCell align="center">{type.mobile_no}</TableCell>
                            <TableCell align="center">{type.email}</TableCell>
                            <TableCell align="center">{type.entity_type}</TableCell>
                            <TableCell align="center">{type.district_name}</TableCell>
                            <TableCell align="center">{type.block_name}</TableCell>
                            <TableCell align="center">{type.gram_panchayat}</TableCell>
                            <TableCell align="center" key={index}>
                              <Tooltip title="Delete" arrow>
                                <IconButton
                                  onClick={() => handleDeleteResource(index)}

                                >
                                  <DeleteIcon sx={{
                                    color: '#e53935', // Red icon color for delete
                                    backgroundColor: 'transparent', // No background color
                                    '&:hover': {
                                      backgroundColor: 'transparent', // No background change on hover
                                      boxShadow: '0 4px 10px #FFFFFF', // Subtle shadow effect on hover
                                    },
                                    transition: 'box-shadow 0.3s', // Smooth transition for shadow only
                                    boxShadow: 'none', // No default shadow
                                    padding: '0px', // No extra padding for clean look
                                  }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="col-md-2 row mt-2">
                      <Button
                        variant="contained"
                        onClick={handleResetAllRows}
                        sx={{
                          width: "70%",
                          backgroundColor: "#4763E430",
                          color: "#4763E4",
                          "&:hover": {
                            backgroundColor: "#4763E4",
                            color: "#fff"
                          },
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div className="col-md-2 row mt-2">
                      <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                          width: "70%",
                          backgroundColor: "#4763E430",
                          color: "#4763E4",
                          "&:hover": {
                            backgroundColor: "#4763E4",
                            color: "#fff"
                          },
                        }}
                      >
                        Submit
                      </Button>

                    </div>
                  </div>

                </>
              )}
            </form>
          </div>
          <ToastContainer />
        </div>
      </div>
    </>
  );
};
export default LineDepartmentDetails;